// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import dimensionsIcon from "@iconify/icons-tabler/dimensions";
import { Portal } from "@mui/base";
// import * as Yup from "yup";
// material
import {
  Card,
  Table,
  Stack,
  // Avatar,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Breadcrumbs,
  Link,
  ListSubheader,
} from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
//
// import LOCATIONLIST from "../_mocks_/location";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";
import { CallApi } from "../statics.js";

const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const TABLE_HEAD = [
  { id: "code", label: "Code", alignRight: false },
  { id: "width", label: "Width", alignRight: false },
  { id: "height", label: "Height", alignRight: false },
  { id: "thickness", label: "Thickness", alignRight: false },
  { id: "price", label: "Price", alignRight: false },
  { id: "priority", label: "Priority", alignRight: false },
  { id: "" },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function DetailItemDimension() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [dialogMode, setDialogMode] = useState("add");

  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("priority");
  const [filterName, setFilterName] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [currentDetailItem, setCurrentDetailItem] = useState({
    id: "",
    title: "",
  });
  const [parnetNameList, setParnetNameList] = useState([]);

  const [codeValue, setCodeValue] = useState("");
  const [codeValueErrorText, setCodeValueErrorText] = useState("");
  const [widthValue, setWidthValue] = useState("");
  const [widthValueErrorText, setWidthValueErrorText] = useState("");
  const [heightValue, setHeightValue] = useState("");
  const [heightValueErrorText, setHeightValueErrorText] = useState("");
  const [thicknessValue, setThicknessValue] = useState("");
  const [thicknessValueErrorText, setThicknessValueErrorText] = useState("");
  const [priceValue, setPriceValue] = useState("");
  const [priceValueErrorText, setPriceValueErrorText] = useState("");
  const [priorityValue, setPriorityValue] = useState("");

  const navigate = useNavigate();

  let params = useParams();

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const formatter = (value) => {
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  useEffect(() => {
    findDetailItemDimensions();
  }, []);

  useEffect(() => {
    if (tableData.length > 0) setDataLoading(false);
  }, [tableData]);

  const findDetailItemDimensions = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      detailItemId: params.detailItemId,
      detailId: params.detailId,
      page: page,
      count: rowsPerPage,
    };
    console.log(data);
    setDataLoading(true);
    CallApi("findDetailItemDimensions", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setTableData(result.result);
          setParnetNameList(result.parnetNameList);
          setTotalItems(result.paginateInfo.totalItems);
        }

        setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) findDetailItemDimensions();
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const handleFilterByName = (event) => {
  //   setFilterName(event.target.value);
  // };

  // useEffect(() => {
  //   if (addDialogOpen) detailTitleTextField.current.focus();
  // }, [addDialogOpen]);

  const handleClickOpen = () => {
    setDialogMode("add");
    setCodeValue("");
    setWidthValue("");
    setHeightValue("");
    setThicknessValue("");
    setPriceValue("");
    setCodeValueErrorText("");
    setWidthValueErrorText("");
    setHeightValueErrorText("");
    setThicknessValueErrorText("");
    setPriceValueErrorText("");
    setPriorityValue("");
    setAddDialogOpen(true);
  };

  const addDetailItem = () => {
    if (!codeValue) {
      setCodeValueErrorText("Code cannot be empty");
      return;
    } else {
      setCodeValueErrorText("");
    }
    if (!widthValue) {
      setWidthValueErrorText("Width cannot be empty");
      return;
    } else {
      setWidthValueErrorText("");
    }
    if (!heightValue) {
      setHeightValueErrorText("Height cannot be empty");
      return;
    } else {
      setHeightValueErrorText("");
    }
    if (!thicknessValue) {
      setThicknessValueErrorText("Thickness cannot be empty");
      return;
    } else {
      setThicknessValueErrorText("");
    }
    if (!priceValue) {
      setPriceValueErrorText("Price cannot be empty");
      return;
    } else {
      setPriceValueErrorText("");
    }

    // if (selectedDetailItemsValue.length < 1) {
    //   setSelectedDetailItemsValueErrorText("Replace with cannot be empty");
    //   return;
    // } else {
    //   setSelectedDetailItemsValueErrorText("");
    // }

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      code: codeValue,
      width: widthValue,
      height: heightValue,
      thickness: thicknessValue,
      price: priceValue,
      detailId: params.detailId,
      detailItemId: params.detailItemId,
      priority: priorityValue,
    };
    let apiname = "addDimensionToDetailItem";

    if (dialogMode === "update") {
      data = {
        username: getCookie("username"),
        token: getCookie("token"),
        detailItemDimensionId: currentDetailItem._id,
        code: codeValue,
        width: widthValue,
        height: heightValue,
        thickness: thicknessValue,
        price: priceValue,
        priority: priorityValue,
      };
      apiname = "updateDetailItemDimensions";
    }

    console.log(data);
    setButtonDisabled(true);

    CallApi(apiname, "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            findDetailItemDimensions();
            setSnackType("success");

            if (apiname === "addDimensionToDetailItem")
              setSnackbarMessage(
                "'" + codeValue + "' has been added successfully"
              );
            else
              setSnackbarMessage(
                "'" + codeValue + "' has been updated successfully"
              );

            setSnackbarOpen(true);
            setAddDialogOpen(false);
          } else {
            setSnackType("error");
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onEditItem = (item) => {
    if (!buttonDisabled) {
      console.log(item);
      setCurrentDetailItem(item);
      setDialogMode("update");
      setCodeValue(item.code);
      setWidthValue(item.width);
      setHeightValue(item.height);
      setThicknessValue(
        item.thickness || item.thickness === 0 ? item.thickness : ""
      );
      setPriceValue(item.price);
      setPriorityValue(
        item.priority || item.priority === 0 ? item.priority : ""
      );
      setCodeValueErrorText("");
      setWidthValueErrorText("");
      setHeightValueErrorText("");
      setThicknessValueErrorText("");
      setPriceValueErrorText("");
      setAddDialogOpen(true);
    }
  };

  const onDeleteItem = (item) => {
    if (!buttonDisabled) {
      setCurrentDetailItem(item);
      setDeleteDialogOpen(true);
    }
  };

  const confirmDeleteItem = () => {
    setDeleteDialogOpen(false);

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      detailItemDimensionId: currentDetailItem._id,
    };

    // console.log(data);

    setButtonDisabled(true);
    CallApi("removeDetailItemDimensions", "post", data)
      .then((result) => {
        try {
          // console.log(result);
          if (result.status === 200) {
            findDetailItemDimensions();
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const getBreadcrumbsLink = (id) => {
    let l = "";
    let end = false;
    parnetNameList.forEach((element) => {
      if (!end) l += "/" + element._id;
      if (id === element._id) end = true;
    });

    return l.toString();
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  return (
    <Page title="Detail Item Dimension | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          ></Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          >
            <Breadcrumbs aria-label="breadcrumb" mb={2}>
              <Link
                key={-1}
                underline="hover"
                color="inherit"
                href={"/details"}
              >
                Details
              </Link>
              {parnetNameList.map((item, i) => {
                if (i === parnetNameList.length - 1) {
                  return (
                    <Typography key={i} color="text.primary">
                      {item.title}
                    </Typography>
                  );
                } else
                  return (
                    <Link
                      key={i}
                      underline="hover"
                      color="inherit"
                      href={"/details" + getBreadcrumbsLink(item._id)}
                    >
                      {item.title}
                    </Link>
                  );
              })}
            </Breadcrumbs>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Dimension
            </Button>
          </Stack>

          <Card>
            {/* <LocationListToolbar
              filterName={filterName}
              searchPlaceHolder="Search title..."
              onFilterName={handleFilterByName}
            /> */}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        const { _id, code, width, height, thickness, price } =
                          row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="normal"
                            >
                              {code}
                            </TableCell>
                            <TableCell>{width}</TableCell>
                            <TableCell>{height}</TableCell>
                            <TableCell>{thickness}</TableCell>
                            <TableCell>
                              {price ? formatter(price) : "-"}
                            </TableCell>
                            <TableCell>
                              {row.priority || row.priority === 0
                                ? row.priority
                                : "-"}
                            </TableCell>
                            <TableCell align="right">
                              <LocationMoreMenu
                                onEdit={() => onEditItem(row)}
                                onDelete={() => onDeleteItem(row)}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}
      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        // keepMounted
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Deleting Dimension</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure for deleting '" + currentDetailItem.code + "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDeleteItem}>Yes</Button>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={addDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setAddDialogOpen(false);
        }}
      >
        <DialogTitle>
          {dialogMode === "add" ? "Add New Dimension" : "Edit Dimension"}
        </DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <TextField
            fullWidth
            sx={{ mb: 2, mt: 2 }}
            autoFocus
            type="text"
            label="Code"
            value={codeValue}
            onChange={(e) => setCodeValue(e.target.value)}
            disabled={buttonDisabled}
            helperText={codeValueErrorText}
            error={codeValueErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            type="text"
            label="Width(mm)"
            value={widthValue}
            onChange={(e) => setWidthValue(e.target.value)}
            disabled={buttonDisabled}
            helperText={widthValueErrorText}
            error={widthValueErrorText ? true : false}
          />
          <TextField
            fullWidth
            sx={{ mb: 2 }}
            type="text"
            label="Height(mm)"
            value={heightValue}
            onChange={(e) => setHeightValue(e.target.value)}
            disabled={buttonDisabled}
            helperText={heightValueErrorText}
            error={heightValueErrorText ? true : false}
          />
          <TextField
            fullWidth
            sx={{ mb: 2 }}
            type="text"
            label="Thickness(mm)"
            value={thicknessValue}
            onChange={(e) => setThicknessValue(e.target.value)}
            disabled={buttonDisabled}
            helperText={thicknessValueErrorText}
            error={thicknessValueErrorText ? true : false}
          />
          <TextField
            fullWidth
            sx={{ mb: 2 }}
            type="text"
            label="Price"
            value={priceValue}
            onChange={(e) => setPriceValue(e.target.value)}
            disabled={buttonDisabled}
            helperText={priceValueErrorText}
            error={priceValueErrorText ? true : false}
            name="priceTextField"
            InputProps={{
              inputComponent: NumericFormatCustom,
            }}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Priority"
            value={priorityValue}
            onChange={(e) => setPriorityValue(e.target.value)}
            disabled={buttonDisabled}
            // helperText={priorityValueErrorText}
            // error={priorityValueErrorText ? true : false}
          />

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={addDetailItem}
            variant="contained"
            disabled={buttonDisabled}
          >
            {dialogMode === "add" ? "Add" : "Update"}
          </Button>
          <Button
            onClick={() => setAddDialogOpen(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
